/**
 * Wire-контракты прав Platform и их проверка на границе (D-056).
 *
 * Ручки пакета Kalmykov Access отвечают без конверта: `CapabilitiesDto`
 * (`roles`, `api`, `ui`) и матрица (`catalog`, `roles`). Допуск роли к
 * ресурсам — массив rid (`Guid[]`).
 */
import { fail, isRecord, list, record } from '../../../shared/decode'
import type { MyAccess, PermissionEntry, AccessMatrix } from '../model/types'

function strings(raw: unknown, field: string): string[] {
  if (raw === undefined || raw === null) return []
  return list(raw, field, (item, name) => (typeof item === 'string' && item.trim() !== '' ? item : fail(`${name} — не строка`)))
}

export function decodeMyAccess(raw: unknown): MyAccess {
  const body = record(raw, 'мои права')
  return { roles: strings(body.roles, 'roles'), api: strings(body.api, 'api') }
}

export function decodeAccessMatrix(raw: unknown): AccessMatrix {
  const body = record(raw, 'матрица прав')
  const catalog: PermissionEntry[] = list(body.catalog, 'catalog', (item, name) => {
    const entry = record(item, name)
    if (typeof entry.key !== 'string' || entry.key === '') fail(`${name}.key — не строка`)
    return {
      key: entry.key,
      title: typeof entry.title === 'string' && entry.title !== '' ? entry.title : entry.key,
      group: typeof entry.group === 'string' && entry.group !== '' ? entry.group : null,
    }
  })
  const roles = body.roles === undefined || body.roles === null ? [] : body.roles
  return {
    catalog,
    roles: list(roles, 'roles', (item, name) => {
      const entry = record(item, name)
      if (typeof entry.role !== 'string' || entry.role === '') fail(`${name}.role — не строка`)
      return { role: entry.role, permissions: strings(entry.permissions, `${name}.permissions`) }
    }),
  }
}

/** Стартовый набор прав роли (RP-FB5): массив ключей матрицы. */
export function decodeRoleDefaults(raw: unknown): string[] {
  if (!Array.isArray(raw)) fail('набор прав роли — не массив')
  return raw.map((item: unknown, index) => (typeof item === 'string' && item !== '' ? item : fail(`[${index}] — не ключ права`)))
}

/** Допуск роли: rid строкой; `ResourceId` объектом тоже принимается. */
export function decodeRoleResources(raw: unknown): string[] {
  if (!Array.isArray(raw)) fail('допуск роли — не массив')
  return raw.map((item: unknown, index) => {
    if (typeof item === 'string' && item !== '') return item
    const value = isRecord(item) ? item.value : undefined
    return typeof value === 'string' && value !== '' ? value : fail(`[${index}] — не идентификатор ресурса`)
  })
}
